<template>
    <div>
        <div class="border shadow-sm p-3 h-100">

            <div class="text-center mt-4">
                <img :src="company.logoPath" :alt="company.name" width="150px">
            </div>
            <p class="text-center mt-3"><strong>{{ company.name }}</strong></p>
            <p class="text-center ds-text-color-grey">{{ company.email }}</p>
            <p class="text-center"><i>Darbinieku skaits: {{ company.userCount }}</i></p>
            <hr/>
            <div class="d-flex justify-content-center mb-3">
                <router-link class="ds-btn mr-1" :to="{name: 'view-company', params: {companyId: company._id}}">
                    <font-awesome-icon icon="eye"/>
                </router-link>
                <b-button @click="handleCompanyRemoval" class="ds-btn ds-btn--danger" :class="{'ds-btn--disabled': isActiveRequest}">
                    <font-awesome-icon icon="trash"/>
                </b-button>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import {Company} from '../../vuex/modules/company/models/company.models';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import * as rootStoreTypes from '../../vuex/root.store-types'

    export default {
        name: 'companies-list-item',
        props: {
            company: {
                type: Company,
                required: true,
            }
        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapActions('company', {
                /** @type {function|*} */
                removeCompany: companyStoreTypes.ACTION_REMOVE_COMPANY,
                /** @type {function|*} */
                getCompanies: companyStoreTypes.ACTION_GET_COMPANIES,
            }),
            async handleCompanyRemoval() {
                // TODO varbut iznest reusable komponentē
                const hasConfirmed = await this.$bvModal.msgBoxConfirm('Esi pārliecināts?', {
                    okTitle: 'Jā',
                    cancelTitle: 'Nē',
                });

                if (!hasConfirmed) {
                    return;
                }

                try {
                    await this.removeCompany(this.company._id);
                    this.setAlertData({type: 'primary', message: 'Uzņēmums izdzēsts!'});
                    this.getCompanies();
                } catch (err) {
                    //
                }
            },
        },
        computed: mapGetters('company', {
            /** @type {function|*} */
            isActiveRequest: companyStoreTypes.GET_IS_ACTIVE_REQUEST,
        }),
    }
</script>